var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { getCampaignsDb, getFacebookCampaignInsights, getFacebookAdsGeneral, getFacebookAdsBreakdown, getGoogleAdsGeneral, getGoogleAdsBreakdown, getGoogleCampaignInsights } from "../../actions/dashboards"; // ajuste aqui
import { Settings } from "lucide-react";
import FacebookRenderer from "../../components/dashboard/platforms/FacebookRenderer";
import GoogleRenderer from "../../components/dashboard/platforms/GoogleRenderer";
import ConfirmModal from "../../components/modals/ConfirmModal"; // Adicione este import
// Para gráficos, use Chart.js ou Recharts. Aqui, exemplo com chart.js-react-lite (fictício, troque pela lib que preferir)
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, LineElement, PointElement, Legend, Tooltip, Title, BarController, LineController, ArcElement, // <-- ADICIONE ESTA LINHA
 } from "chart.js";
ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Legend, Tooltip, Title, BarController, LineController, ArcElement // <-- ADICIONE ESTA LINHA
);
var Dashboard = function () {
    var _a = useParams(), id = _a.id, name = _a.name, periodParam = _a.period;
    var navigate = useNavigate();
    var location = useLocation();
    var _b = useState(periodParam || "last_30_days"), period = _b[0], setPeriod = _b[1];
    var _c = useState({ start: "", end: "" }), customRange = _c[0], setCustomRange = _c[1];
    var _d = useState(null), googleAdsData = _d[0], setGoogleAdsData = _d[1];
    var _e = useState(null), facebookGeneral = _e[0], setFacebookGeneral = _e[1];
    var _f = useState(null), facebookBreakdown = _f[0], setFacebookBreakdown = _f[1];
    var _g = useState(null), instagramData = _g[0], setInstagramData = _g[1];
    var _h = useState(null), googleGeneral = _h[0], setGoogleGeneral = _h[1];
    var _j = useState(null), googleBreakdown = _j[0], setGoogleBreakdown = _j[1];
    // Campanhas salvas no banco
    var _k = useState([]), campaigns = _k[0], setCampaigns = _k[1];
    var _l = useState({}), facebookCampaignsInsights = _l[0], setFacebookCampaignsInsights = _l[1];
    var _m = useState({}), googleCampaignsInsights = _m[0], setGoogleCampaignsInsights = _m[1];
    var _o = useState(true), loadingCampaigns = _o[0], setLoadingCampaigns = _o[1];
    // Estado do modal de aviso
    var _p = useState(false), modalOpen = _p[0], setModalOpen = _p[1];
    useEffect(function () {
        setModalOpen(true);
    }, []);
    // Buscar campanhas e insights
    useEffect(function () {
        if (period === "custom" && (!customRange.start || !customRange.end))
            return;
        if (!id)
            return;
        setLoadingCampaigns(true);
        var fetchAll = function () { return __awaiter(void 0, void 0, void 0, function () {
            var res, facebookObj_1, googleObj_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, getCampaignsDb(id)];
                    case 1:
                        res = _b.sent();
                        setCampaigns(res.data);
                        facebookObj_1 = {};
                        googleObj_1 = {};
                        return [4 /*yield*/, Promise.all(res.data.map(function (camp) { return __awaiter(void 0, void 0, void 0, function () {
                                var insightsRes, insightsRes, _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            _b.trys.push([0, 5, , 6]);
                                            if (!(camp.platform === "facebook")) return [3 /*break*/, 2];
                                            return [4 /*yield*/, getFacebookCampaignInsights(id, camp.id, period, customRange.start, customRange.end)];
                                        case 1:
                                            insightsRes = _b.sent();
                                            facebookObj_1[camp.id] = insightsRes.data || [];
                                            return [3 /*break*/, 4];
                                        case 2:
                                            if (!(camp.platform === "google")) return [3 /*break*/, 4];
                                            return [4 /*yield*/, getGoogleCampaignInsights(id, camp.id, period, customRange.start, customRange.end)];
                                        case 3:
                                            insightsRes = _b.sent();
                                            googleObj_1[camp.id] = insightsRes.data || [];
                                            _b.label = 4;
                                        case 4: return [3 /*break*/, 6];
                                        case 5:
                                            _a = _b.sent();
                                            if (camp.platform === "facebook")
                                                facebookObj_1[camp.id] = [];
                                            if (camp.platform === "google")
                                                googleObj_1[camp.id] = [];
                                            return [3 /*break*/, 6];
                                        case 6: return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 2:
                        _b.sent();
                        setFacebookCampaignsInsights(facebookObj_1);
                        setGoogleCampaignsInsights(googleObj_1);
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        setCampaigns([]);
                        setFacebookCampaignsInsights({});
                        setGoogleCampaignsInsights({});
                        return [3 /*break*/, 4];
                    case 4:
                        setLoadingCampaigns(false);
                        return [2 /*return*/];
                }
            });
        }); };
        fetchAll();
        // eslint-disable-next-line
    }, [id, period, customRange]);
    // Facebook General e Google General
    useEffect(function () {
        if (!id)
            return;
        if (period === "custom" && (!customRange.start || !customRange.end))
            return;
        setFacebookGeneral(null);
        setGoogleGeneral(null);
        var fetchGeneral = function () { return __awaiter(void 0, void 0, void 0, function () {
            var fbGeneral, gglGeneral, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 8]);
                        fbGeneral = void 0, gglGeneral = void 0;
                        if (!(period === "custom")) return [3 /*break*/, 3];
                        return [4 /*yield*/, getFacebookAdsGeneral(id, period, customRange.start, customRange.end)];
                    case 1:
                        fbGeneral = _a.sent();
                        return [4 /*yield*/, getGoogleAdsGeneral(id, period, customRange.start, customRange.end)];
                    case 2:
                        gglGeneral = _a.sent();
                        return [3 /*break*/, 6];
                    case 3: return [4 /*yield*/, getFacebookAdsGeneral(id, period)];
                    case 4:
                        fbGeneral = _a.sent();
                        return [4 /*yield*/, getGoogleAdsGeneral(id, period)];
                    case 5:
                        gglGeneral = _a.sent();
                        _a.label = 6;
                    case 6:
                        setFacebookGeneral(fbGeneral.data);
                        setGoogleGeneral(gglGeneral.data);
                        return [3 /*break*/, 8];
                    case 7:
                        error_1 = _a.sent();
                        setFacebookGeneral(null);
                        setGoogleGeneral(null);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        fetchGeneral();
        // eslint-disable-next-line
    }, [id, period, customRange]);
    // Facebook Breakdown
    useEffect(function () {
        if (!id)
            return;
        if (period === "custom" && (!customRange.start || !customRange.end))
            return;
        setFacebookBreakdown(null);
        var fetchBreakdown = function () { return __awaiter(void 0, void 0, void 0, function () {
            var breakdown, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        breakdown = void 0;
                        if (!(period === "custom")) return [3 /*break*/, 2];
                        return [4 /*yield*/, getFacebookAdsBreakdown(id, period, customRange.start, customRange.end)];
                    case 1:
                        breakdown = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, getFacebookAdsBreakdown(id, period)];
                    case 3:
                        breakdown = _a.sent();
                        _a.label = 4;
                    case 4:
                        setFacebookBreakdown(breakdown.data.current);
                        return [3 /*break*/, 6];
                    case 5:
                        error_2 = _a.sent();
                        setFacebookBreakdown(null);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        fetchBreakdown();
        // eslint-disable-next-line
    }, [id, period, customRange]);
    // Google Breakdown
    useEffect(function () {
        if (!id)
            return;
        if (period === "custom" && (!customRange.start || !customRange.end))
            return;
        setGoogleBreakdown(null);
        var fetchBreakdown = function () { return __awaiter(void 0, void 0, void 0, function () {
            var breakdown, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        breakdown = void 0;
                        if (!(period === "custom")) return [3 /*break*/, 2];
                        return [4 /*yield*/, getGoogleAdsBreakdown(id, period, customRange.start, customRange.end)];
                    case 1:
                        breakdown = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, getGoogleAdsBreakdown(id, period)];
                    case 3:
                        breakdown = _a.sent();
                        _a.label = 4;
                    case 4:
                        setGoogleBreakdown(breakdown.data);
                        return [3 /*break*/, 6];
                    case 5:
                        error_3 = _a.sent();
                        setGoogleBreakdown(null);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        fetchBreakdown();
        // eslint-disable-next-line
    }, [id, period, customRange]);
    var periodOptions = [
        { label: "Hoje", value: "today" },
        { label: "Ontem", value: "yesterday" },
        { label: "Últimos 7 dias", value: "last_7_days" },
        { label: "Últimos 14 dias", value: "last_14_days" },
        { label: "Últimos 28 dias", value: "last_28_days" },
        { label: "Últimos 30 dias", value: "last_30_days" },
        { label: "Esta semana", value: "this_week" },
        { label: "Semana passada", value: "last_week" },
        { label: "Este mês", value: "this_month" },
        { label: "Mês passado", value: "last_month" },
        { label: "Máximo", value: "max" },
        { label: "Personalizado", value: "custom" },
    ];
    // Quando mudar o período, altere a URL:
    var handlePeriodChange = function (newPeriod) {
        if (newPeriod === "custom") {
            setPeriod("custom");
            // Não navega nem busca dados ainda, só mostra os inputs
        }
        else {
            setPeriod(newPeriod);
            navigate("/dashboards/".concat(name, "/").concat(id, "/").concat(newPeriod));
        }
    };
    // Atualize as datas customizadas e a URL
    var handleCustomDateChange = function (field, value) {
        var _a;
        var updated = __assign(__assign({}, customRange), (_a = {}, _a[field] = value, _a));
        setCustomRange(updated);
        if (period === "custom" && updated.start && updated.end) {
            navigate("/dashboards/".concat(name, "/").concat(id, "/custom?start=").concat(updated.start, "&end=").concat(updated.end));
        }
    };
    // Ao montar, se for custom, pegue as datas da query string
    useEffect(function () {
        if (periodParam === "custom") {
            var params = new URLSearchParams(location.search);
            var start = params.get("start") || "";
            var end = params.get("end") || "";
            setCustomRange({ start: start, end: end });
        }
        // eslint-disable-next-line
    }, [periodParam, location.search]);
    return (React.createElement("div", { className: "min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white p-0" },
        React.createElement("div", { className: "w-full bg-gradient-to-r from-blue-500 to-cyan-400 py-2 px-8 flex justify-between items-center" },
            React.createElement("span", { className: "font-semibold tracking-widest text-sm" }, name ? name.toUpperCase() : "CLIENTE"),
            React.createElement("button", { className: "flex items-center gap-2 text-xs bg-blue-700 hover:bg-blue-800 px-3 py-1 rounded transition", onClick: function () { return window.location.href = "/dashboards-settings/".concat(name, "/").concat(id); }, title: "Configura\u00E7\u00F5es das campanhas" },
                React.createElement(Settings, { className: "h-4 w-4" }),
                "Configura\u00E7\u00F5es de campanhas")),
        React.createElement(FacebookRenderer, { facebookGeneral: facebookGeneral, facebookBreakdown: facebookBreakdown, period: period, periodOptions: periodOptions, customRange: customRange, handlePeriodChange: handlePeriodChange, handleCustomDateChange: handleCustomDateChange, loadingCampaigns: loadingCampaigns, campaigns: campaigns, campaignsInsights: facebookCampaignsInsights, name: name, id: id }),
        React.createElement(GoogleRenderer, { googleGeneral: googleGeneral, loadingCampaigns: loadingCampaigns, googleBreakdown: googleBreakdown, campaigns: campaigns, campaignsInsights: googleCampaignsInsights, name: name, id: id }),
        React.createElement(ConfirmModal, { open: modalOpen, title: "Dashboards em desenvolvimento", description: React.createElement(React.Fragment, null,
                "A visualiza\u00E7\u00E3o de dashboards est\u00E1 em desenvolvimento.",
                React.createElement("br", null),
                React.createElement("span", { className: "font-semibold text-yellow-300" }, "Estamos trabalhando para trazer a melhor experi\u00EAncia de visualiza\u00E7\u00E3o de dados.")), onConfirm: function () { return setModalOpen(false); }, onCancel: function () { return setModalOpen(false); }, confirmText: "Ok, entendi", loading: false }),
        React.createElement("div", { style: { height: "6rem" } })));
};
export default Dashboard;
